var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "billing-address-form" }, [
    _c("div", { staticClass: "payment-card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "payment-card__content" }, [
        _c("div", { staticClass: "address-info" }, [
          _c("div", { staticClass: "address-item full-width" }, [
            _c(
              "div",
              { staticClass: "billing-type-container" },
              [
                _c("span", { staticClass: "billing-type-label" }, [
                  _vm._v("Fatura Türü:"),
                ]),
                _vm._v(" "),
                _c("a-switch", {
                  staticClass: "billing-type-switch",
                  attrs: {
                    "checked-children": "Şirket",
                    "un-checked-children": "Bireysel",
                  },
                  model: {
                    value: _vm.form.isCompany,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "isCompany", $$v)
                    },
                    expression: "form.isCompany",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "address-columns" }, [
            _vm.form.isCompany
              ? _c(
                  "div",
                  {
                    staticClass: "address-item",
                    class: { "has-error": _vm.errors.companyName },
                  },
                  [
                    _c("a-icon", { attrs: { type: "shop" } }),
                    _vm._v(" "),
                    _c("a-input", {
                      staticClass: "edit-input",
                      attrs: {
                        "data-field": "companyName",
                        placeholder: "Şirket Adı*",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.handleInput("companyName")
                        },
                      },
                      model: {
                        value: _vm.form.companyName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "companyName", $$v)
                        },
                        expression: "form.companyName",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  {
                    staticClass: "address-item",
                    class: { "has-error": _vm.errors.fullName },
                  },
                  [
                    _c("a-icon", { attrs: { type: "user" } }),
                    _vm._v(" "),
                    _c("a-input", {
                      staticClass: "edit-input",
                      attrs: {
                        "data-field": "fullName",
                        placeholder: "Ad Soyad*",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.handleInput("fullName")
                        },
                      },
                      model: {
                        value: _vm.form.fullName,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "fullName", $$v)
                        },
                        expression: "form.fullName",
                      },
                    }),
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "address-item",
                class: { "has-error": _vm.errors.email },
              },
              [
                _c("a-icon", { attrs: { type: "mail" } }),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "edit-input",
                  attrs: {
                    "data-field": "email",
                    type: "email",
                    placeholder: "E-Posta*",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.handleInput("email")
                    },
                  },
                  model: {
                    value: _vm.form.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "email", $$v)
                    },
                    expression: "form.email",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "address-columns" }, [
            !_vm.form.isCompany
              ? _c(
                  "div",
                  {
                    staticClass: "address-item",
                    class: { "has-error": _vm.errors.identityNumber },
                  },
                  [
                    _c("a-icon", { attrs: { type: "idcard" } }),
                    _vm._v(" "),
                    _c("a-input", {
                      staticClass: "edit-input",
                      attrs: {
                        "data-field": "identityNumber",
                        placeholder: "TC Kimlik Numarası*",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.handleInput("identityNumber")
                        },
                      },
                      model: {
                        value: _vm.form.identityNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "identityNumber", $$v)
                        },
                        expression: "form.identityNumber",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.form.isCompany
              ? _c(
                  "div",
                  {
                    staticClass: "address-item",
                    class: { "has-error": _vm.errors.taxNumber },
                  },
                  [
                    _c("a-icon", { attrs: { type: "number" } }),
                    _vm._v(" "),
                    _c("a-input", {
                      staticClass: "edit-input",
                      attrs: {
                        "data-field": "taxNumber",
                        placeholder: "Vergi Numarası*",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.handleInput("taxNumber")
                        },
                      },
                      model: {
                        value: _vm.form.taxNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taxNumber", $$v)
                        },
                        expression: "form.taxNumber",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.form.isCompany
              ? _c(
                  "div",
                  {
                    staticClass: "address-item",
                    class: { "has-error": _vm.errors.taxOffice },
                  },
                  [
                    _c("a-icon", { attrs: { type: "audit" } }),
                    _vm._v(" "),
                    _c("a-input", {
                      staticClass: "edit-input",
                      attrs: {
                        "data-field": "taxOffice",
                        placeholder: "Vergi Dairesi*",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.handleInput("taxOffice")
                        },
                      },
                      model: {
                        value: _vm.form.taxOffice,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "taxOffice", $$v)
                        },
                        expression: "form.taxOffice",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "address-columns" }, [
            _c(
              "div",
              {
                staticClass: "address-item",
                class: { "has-error": _vm.errors.billingCountry },
              },
              [
                _c("a-icon", { attrs: { type: "global" } }),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "edit-input",
                  attrs: {
                    "data-field": "billingCountry",
                    placeholder: "Ülke*",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.handleInput("billingCountry")
                    },
                  },
                  model: {
                    value: _vm.form.billingCountry,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "billingCountry", $$v)
                    },
                    expression: "form.billingCountry",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "address-item",
                class: { "has-error": _vm.errors.billingCity },
              },
              [
                _c("a-icon", { attrs: { type: "environment" } }),
                _vm._v(" "),
                _c("a-input", {
                  staticClass: "edit-input",
                  attrs: { "data-field": "billingCity", placeholder: "Şehir*" },
                  on: {
                    input: function ($event) {
                      return _vm.handleInput("billingCity")
                    },
                  },
                  model: {
                    value: _vm.form.billingCity,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "billingCity", $$v)
                    },
                    expression: "form.billingCity",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "address-item flex-start-item full-width",
              class: { "has-error": _vm.errors.billingAddress },
            },
            [
              _c("a-icon", { attrs: { type: "home" } }),
              _vm._v(" "),
              _c("a-textarea", {
                staticClass: "edit-input",
                attrs: {
                  "data-field": "billingAddress",
                  placeholder: "Tam Adres*",
                  rows: 3,
                },
                on: {
                  input: function ($event) {
                    return _vm.handleInput("billingAddress")
                  },
                },
                model: {
                  value: _vm.form.billingAddress,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "billingAddress", $$v)
                  },
                  expression: "form.billingAddress",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "SupsisButton",
          {
            attrs: { ghost: "" },
            on: {
              click: function ($event) {
                return _vm.$emit("cancel")
              },
            },
          },
          [_vm._v("İptal")]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { primary: "" }, on: { click: _vm.submitForm } },
          [_vm._v("Devam Et")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "payment-card__header" }, [
      _c("div", { staticClass: "payment-card__title" }, [
        _vm._v("Fatura Adresi"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }